import React, { useState } from 'react';
import {Link} from 'react-router-dom';
import Logo from '../images/Logo.PNG';
 
function NavBar() {
    const [menuOpen, setMenuOpen] = useState(false);
 
    const toggleMenu = () => setMenuOpen(prev => !prev);
    const closeMenu = () => setMenuOpen(false);
 
    return(
      <nav id="nav">
        <img src={Logo} className="logo" alt="Logo" />
 
        <button
          className={`hamburger ${menuOpen ? 'open' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
          aria-expanded={menuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
 
        <ul className={`nav-list ${menuOpen ? 'nav-open' : ''}`}>
          <li className="active"><Link to="/" onClick={closeMenu}>Home</Link></li>
          <li><a href="https://www.linkedin.com/in/catherine-ellis-coldren-a003b9196" target="_blank" rel="noopener noreferrer" onClick={closeMenu}>LinkedIn</a></li>
          <li><a href="https://github.com/ellis-coldren" target="_blank" rel="noopener noreferrer" onClick={closeMenu}>GitHub</a></li>
          <li><Link to="/ThanksforVisiting" onClick={closeMenu}>Thank you &#9829;</Link></li>
        </ul>
      </nav>
    );
}
export default NavBar